import React from 'react';
import './Footer.css';
import { FaLinkedin, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import trade  from '../trademark.png';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-icon">
                {/* <div className="logo-circle logo-circle-1"></div>
                <div className="logo-circle logo-circle-2"></div> */}
                <img src={trade} alt="Logo" />

              </div>
              <span className="logo-text" style={{color: 'white'}}>CodeGenexis</span>
            </div>
            <div className="social-media">
              <a href="#" className="social-icon"><FaLinkedin /></a>
              <a href="#" className="social-icon"><FaFacebook /></a>
              <a href="#" className="social-icon"><FaInstagram /></a>
              <a href="#" className="social-icon"><FaTwitter /></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Software Development</a></li>
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">Digital Marketing</a></li>
              <li><a href="#services">App Development</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              {/* <li><a href="#contact">Contact</a></li> */}
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <div className="contact-info">
              <p>Banasthali, Kathmandu</p>
              <p>+977 9709072209</p>
              <p>codegenexisofficial@gmail.com</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            Copyright © {new Date().getFullYear()} CodeGenexis
          </div>
          <button className="scroll-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            ↑
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 